<template>
  <div class="home">
    <h3 v-if="isPc">填写预订信息</h3>
    <div class="order-item" v-for="(item,index) in orders" :key="index">
      <div class="order-info">
        <div>
          <p>
            房型：
            <span>{{item.hotelType}}</span>
          </p>
          <p>预定方式： {{item.sellType | measureType}}</p>
          <p>{{item.sellType === 0 ? '房间' : '床位'}}价格：￥{{item.sellType === 0 ? item.roomPrice : item.bedPrice}}</p>
        </div>
      </div>
      <div v-if="isPc" class="choose-time">
        <div class="desc">
           入离日期
        </div>
        <div class="leave-time">
            入店日期
            <p>
            <span>
              <span v-if="item.canSelectDate!==1">{{item.startDate}}</span>
              <el-date-picker
                      v-else
                      :picker-options="item.pickerOptionsEnd"
                      v-model="item.startDate"
                      type="date"
                      @change="changeStart(item)"
                      format="yyyy-MM-dd"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd">
            </el-date-picker>
            </span>
            <span>{{ getWeek(item.startDate)}}</span>
          </p>
        </div>
        <div class="leave-time">
            离店日期
            <p>
            <span>
              <span v-if="item.canSelectDate!==1">{{item.endDate}}</span>
              <el-date-picker
                      v-else
                      :picker-options="item.pickerOptionsEnd"
                      v-model="item.endDate"
                      type="date"
                      @change="changeEnd(item)"
                      placeholder="选择日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd">
            </el-date-picker>
            </span>
            <span>{{getWeek(item.endDate)}}</span>
          </p>
        </div>
      </div>
      <div v-else class="time">
        <div class="enter-time">
          <p>入住></p>
          <p>
            <span>
              <span v-if="item.canSelectDate!==1">{{item.startDate}}</span>
              <el-date-picker
                      v-else
                      :picker-options="item.pickerOptionsEnd"
                      v-model="item.startDate"
                      type="date"
                      @change="changeStart(item)"
                      format="yyyy-MM-dd"
                      placeholder="选择日期"
                      value-format="yyyy-MM-dd">
            </el-date-picker>
            </span>
            <span>{{ getWeek(item.startDate)}}</span>
          </p>
        </div>
        <div class="leave-time">
          <p>离店></p>
          <p>
            <span>
              <span v-if="item.canSelectDate!==1">{{item.endDate}}</span>
              <el-date-picker
                      v-else
                      :picker-options="item.pickerOptionsEnd"
                      v-model="item.endDate"
                      type="date"
                      @change="changeEnd(item)"
                      placeholder="选择日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd">
            </el-date-picker>
            </span>
            <span>{{getWeek(item.endDate)}}</span>
          </p>
        </div>
      </div>
      <div class="rooms">
        <div class="rooms-num">
          <div>
            <span>{{item.sellType === 0 ? '房间数' : '床位数'}}</span>
          </div>
          <div>{{item.ordernum}} 间</div>
          <div class="arrow">
            <span>></span>
          </div>
        </div>
        <div class="rooms-num roomPhone" v-for="(it, index) in item.roomList" :key="`room${index}`">
          <div>{{item.sellType === 0 ? '房间' : '床位'}}{{index+1}}: </div>
          <div>
            <input type="text" placeholder="入住人姓名，每间填1人" v-model="it.customerName" />
          </div>
          
          <div>
            <!--                      <img class="check" src="../../views/tickets/static/checked.png" alt="" >-->
            <span>
              <span
                :class="{'check': it.gender === '1', 'uncheck': it.gender !== '1'}"
                @click="it.gender = '1'"
              ></span> 男
            </span>
            <!--                      <img class="check" src="../../views/tickets/static/unchecked.png" alt="">-->
            <span>
              <span
                :class="{'check': it.gender === '2', 'uncheck': it.gender !== '2'}"
                @click="it.gender = '2'"
              ></span> 女
            </span>
          </div>
          <div>
             <p>电话: </p>
             <input type="text" placeholder="入住人电话，每间填1人" v-model="it.customerPhone" />
          </div>
        </div>
      </div>
      
      <div class="total">
        <span>合计</span>
        <span style="color: #FF4E00;">¥{{item.totalPrice}}</span>
      </div>
    </div>

    <div v-if="isPc" class="price-bottom">
      <div class="price">
        总计：<span>¥{{totalprice}}</span>
      </div>
      <div class="next-btn" @click="toNext">下一步</div>
    </div>


    <div v-else class="btn-bottom">
      <div class="price">
        总计：
        <span>¥{{totalprice}}</span>
      </div>
      <div class="next-btn" @click="toNext">下一步</div>
    </div>
  </div>
</template>

<script>
import http from '@/utils/http'
import apis from '@/utils/apis'
export default {
  data() {
    return {
      orders: [
        {
          room: '标准间',
          type: '整间',
          price: 400,
          enterDate: '8-21',
          enterWeek: '周三',
          leaveDate: '8-23',
          leaveWeek: '周五',
          number: 3,
          roomList: [
            {
              sex: '1',
              name: ''
            },
            {
              sex: '1',
              name: ''
            },
            {
              sex: '1',
              name: ''
            }
          ]
        },
        {
          room: '标准间',
          type: '整间',
          price: 400,
          enterDate: '8-21',
          enterWeek: '周三',
          leaveDate: '8-23',
          leaveWeek: '周五',
          number: 3,
          roomList: [
            {
              sex: '1',
              name: ''
            },
            {
              sex: '1',
              name: ''
            },
            {
              sex: '1',
              name: ''
            }
          ]
        }
      ],
      totalprice: 0,
      contacts: ''
    }
  },
  methods: {
    /**
     * 根据日期字符串获取星期几
     * @param dateString 日期字符串（如：2020-05-02）
     * @returns {String}
     */
    getWeek(dateString) {
      if(dateString){
          const dateArray = dateString.split("-");
          const date = new Date(dateArray[0], parseInt(dateArray[1] - 1), dateArray[2]);
          return "周" + "日一二三四五六".charAt(date.getDay());
      }
    },
    //开始时间改变
    changeStart(item) {
      console.log('changeItem111', item)
      let startDate = new Date(item.startDate)
      
      let endDate = new Date(item.endDate)
      
      let days = endDate.getTime() - startDate.getTime();
      let dateNum=parseInt(days / (1000 * 60 * 60 * 24))
      item.totalPrice = item.sellType === 0 ? item.ordernum * item.roomPrice*dateNum : item.ordernum * item.bedPrice*dateNum;
      this.totalprice=0
      this.orders.forEach((item) => {
        this.totalprice +=  item.totalPrice
      })
      // item.pickerOptionsEnd = {
      //   disabledDate(time) {
      //     let start = new Date()
      //     let end = null
      //     if (item.liveStartDate) {
      //       start = new Date(item.liveStartDate)
      //     }
      //     if (item.startDate) {
      //       start = new Date(item.startDate)
      //     }
      //     if (item.liveEndDate) {
      //       end = new Date(item.liveEndDate)
      //     }
      //     if (end) {
      //       // console.log('time111', time.getTime())
      //       // let days = maxDate.getTime() - minDate.getTime();
      //       let bool= time.getTime() < start.getTime() || time.getTime() > end.getTime()
      //       console.log('当前日期',bool)
      //       return bool
      //     } else {
      //       // console.log('time2222', time.getTime())
      //       return time.getTime() < start.getTime()
      //     }
      //   }
      // }
    },
    //结束时间改变
    changeEnd(item) {
      console.log('changeItem2222', item)
      let startDate = new Date(item.startDate)
      
      let endDate = new Date(item.endDate)
      
      let days = endDate.getTime() - startDate.getTime();
      let dateNum=parseInt(days / (1000 * 60 * 60 * 24)) || 0
      item.totalPrice = item.sellType === 0 ? item.ordernum * item.roomPrice*dateNum : item.ordernum * item.bedPrice*dateNum;
      this.totalprice=0
      this.orders.forEach((item) => {
        this.totalprice +=  item.totalPrice
      })
      item.pickerOptionsEnd ={
        disabledDate(time) {
          let start = new Date()
          let end = null
          if (item.minTime) {
            start = new Date(item.minTime)
          }
          if (item.minTime) {
            start = new Date(item.minTime)
          }
          if (item.maxTime) {
            end = new Date(item.maxTime)
          }
          if (end) {
            let bool= time.getTime() < start.getTime() || time.getTime() > end.getTime()
            // console.log('当前日期',bool)
            return bool
          } else {
            return time.getTime() < start.getTime()
          }
        }
      } 
    },
    toNext() {
      for (let i = 0; i < this.orders.length; i++) {
        const item = this.orders[i]
        if (!item.startDate) {
          this.$alert('请选择入住日期', '',{
              showClose: false
          })
          return
        }
        if (!item.endDate) {
          this.$alert('请选择离店日期', '',{
              showClose: false
          })
          return
        }
        for (let j = 0; j < item.roomList.length; j++) {
          const roomItem = item.roomList[j]
          if (!roomItem.customerName) {
            this.$alert('请填写入住人姓名', '',{
                    showClose: false
                  })
            return
          }
        }
        for (let j = 0; j < item.roomList.length; j++) {
          const roomItem = item.roomList[j]
          if (!roomItem.customerPhone) {
            this.$alert('请填写入住人电话', '',{
                    showClose: false
                  })
            return
          }
        }
      }
      const currentRoom = { roomList: this.orders, totalPrice: this.totalprice }

      this.$store.commit('SET_CURRENT_ROOM', currentRoom)
      this.toOrder()
      // this.$router.push('/order_info')
    },
    async toOrder() {
        console.log(this.orders)
        let hotelOrderDetails = []
        this.orders.forEach(item=>{
            const list = item.roomList.map(roomItem=>{
                return {
                  startDate: item.startDate+ ' 00:00:00',
                  endDate: item.endDate+ ' 00:00:00',
                  gender: roomItem.gender,
                  customerName: roomItem.customerName,
                  customerPhone: roomItem.customerPhone,
                  price: item.sellType === 0 ? item.roomPrice : item.bedPrice,
                  hotelRoomId: item.id,
                  hotelName: item.hotelName,
                  hotelType: item.hotelType,
                  sellType: item.sellType
                }
            })
            hotelOrderDetails = [...hotelOrderDetails, ...list]
        })
        console.log(this.totalPrice)
        const data = {
          amount: this.totalprice,
          audienceId: localStorage.getItem('audienceId'),
          payType: 0,
          meetingId: this.meetingId,
          hotelName: this.currentHotel.hotelName,
          contacts: this.contacts,
          hotelOrderDetails: hotelOrderDetails
        }
        const res = await http.post(apis.submitBookOrder, data)
        if (res.code === 0) {
          localStorage.setItem('hotelOrderNo', res.orderNo)
          // this.$store.commit('SET_CURRENT_ROOM', {})
          // this.$store.commit('SET_CURRENT_HOTEL', {})
          this.$router.push('/order_info')
        } else {
          this.$alert(res.msg, '',{
                    showClose: false
                  })
        }
    },
    async getUserInfo() {
          const params = {
              audienceId: localStorage.getItem('audienceId')
          }
          const res = await http.get(`/renren-fast/app/audienceCenter/getAudienceInfo/${this.meetingId}`, {params})
          if(res.code===0){
              console.log(res)
              this.contacts = res.audience.contacts
          }
      }
  },
  computed: {
    isPc() {
      return this.$store.state.isPc
    },
    currentRoom() {
      return this.$store.state.currentRoom.roomList
    },
    meetingId() {
      return this.$store.state.meetingId || localStorage.getItem('meetingId')
    },
    currentHotel() {
      return this.$store.state.currentHotel
    }
  },
  created() {
    this.orders = this.currentRoom
    console.log('currentRoom', this.currentRoom )
    this.totalprice = 0
    this.getUserInfo()
    this.orders.forEach((item) => {
      item.canSelectDate = item.sellType === 0 ? item.packageCanSelectDateTwo : item.liveCanSelectDate
      console.log(item.canSelectDate)
      if (item.canSelectDate!==1) {
          item.startDate = JSON.parse(localStorage.getItem('meeting')).startTime.split(' ')[0]
          item.endDate = JSON.parse(localStorage.getItem('meeting')).endTime.split(' ')[0]
          if(item.startDate === item.endDate){
              item.endDate = item.endDate.split('-')[0] + '-' +item.endDate.split('-')[1] + '-' + parseInt[(item.endDate.split('-')[2])+1]
          }
          let startDate = new Date(item.startDate)
      
        let endDate = new Date(item.endDate)
        
        let days = endDate.getTime() - startDate.getTime();
        let dateNum=parseInt(days / (1000 * 60 * 60 * 24))
        console.log(dateNum)
        item.totalPrice = item.sellType === 0 ? item.ordernum * item.roomPrice*dateNum : item.ordernum * item.bedPrice*dateNum;
        // this.totalprice=0
        console.log(item.totalPrice)
        this.totalprice += item.totalPrice
        console.log(this.totalPrice)
      }else{
          this.$set(item, 'minTime', item.liveStartDate)
          this.$set(item, 'maxTime', item.liveEndDate)
          item.totalPrice = item.sellType === 0 ? item.ordernum * item.roomPrice : item.ordernum * item.bedPrice;
          this.totalprice = this.totalprice + item.totalPrice
          this.$set(item, 'pickerOptionsStart', {})
          this.$set(item, 'pickerOptionsEnd', {})
          // 设置时间选择限制
          // this.changeStart(item)
          this.changeEnd(item)
      }
      
      
      // this.orders.forEach((item) => {
      //   this.totalprice +=  item.totalPrice
      // })
      
      if (!item.roomList) {
        this.$set(item, 'roomList', [])
        for( let i = 0; i < item.ordernum; i++){
          item.roomList.push({
            gender: '1',
            customerName: '',
            customerPhone:''
          })
        }
      }
    })

  }
}
</script>

<style lang="stylus" scoped>
  input::placeholder{
    color:#ccc;
  }
  /*修改element-ui日期選擇樣式*/
  /deep/.el-input__inner{
    color: #ff4e00;
    font-size: 32px;
    border: none;
    padding: 0px;
    /*margin-right: 2.133vw;*/
  }
    .enter-time, .leave-time {
      /deep/ .el-date-picker .el-date-table{
        font-size: 30px;
      }
      /deep/.el-input__icon:after, /deep/.el-icon-date:before {
        content: ''
        height: 0px;
        width 0px;
      }
      /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 170px;
      }
    }
  .home {
    padding-bottom: 100px
  }
.order-item {
  background: #ffffff;

  .order-info {
    padding: 20px;
    color: #fff;
    font-size: 26px;
    border-bottom: 1px solid #D7D7D7;

    div {
      width: 100%;
      height: 116px;
      display: flex;
      align-content: center;
      flex-wrap: wrap;
      background: rgba(117, 170, 211, 1);
      border-radius: 10px;
      color: #ffffff;
      padding: 20px;
      box-sizing: border-box;

      p {
        width: 50%;
        display: inline-block;
        text-align: left;
      }

      p:nth-of-type(1) {
        width: 100%;
        margin-bottom: 20px;
      }
    }
  }
}

.time {
  padding: 10px;
  border-bottom: 1px solid #D7D7D7;
  display: flex;
  align-content: center;
  height: 112px;

  >div:nth-of-type(1) {
    border-right: 1px solid #D7D7D7;
  }

  >div {
    width: 50%;
    text-align: center;

    p:nth-of-type(1) {
      font-size: 28px;
      color: #4C4C4C;
      margin-bottom: 20px;
    }

    p:nth-of-type(2) {
      span:nth-of-type(1) {
        color: #FF4E00;
        font-size: 32px;
        margin-right: 16px;
      }

      span:nth-of-type(2) {
        color: #727272;
        font-size: 22px;
      }
    }
  }
}

.rooms {
  padding: 0 24px;
}

.total {
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 77px;
  font-size: 28px;
  border-bottom: 1px solid #D7D7D7;
}

.rooms-num {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 77px;
  font-size: 28px;
  border-bottom: 1px solid #D7D7D7;

  div:nth-of-type(1) {
    width: 100px;
  }

  div:nth-of-type(2) {
    width: 300px;
    text-align: left;

    input {
      font-size: 28px;
      border: none;
    }
  }

  div:nth-of-type(3) {
    width: 165px;
    display: flex;
    align-items: center;

    img {
      width: 28px;
      margin-right: 12px;
    }

    >span:nth-of-type(1) {
      margin-right: 20px;
    }

    .check {
      display: inline-block;
      width: 28px;
      height: 28px;
      vertical-align: text-top;
      background: url('../../views/tickets/static/checked.png');
      -webkit-background-size: 28px 28px;
      background-size: 28px 28px;
    }

    .uncheck {
      display: inline-block;
      width: 28px;
      height: 28px;
      vertical-align: text-top;
      background: url('../../views/tickets/static/unchecked.png');
      -webkit-background-size: 28px 28px;
      background-size: 28px 28px;
    }
  }

  .arrow {
    text-align: right;
    position: relative;

    span {
      position: absolute;
      right: 0;
      transform: rotate(90deg);
    }
  }
}
.roomPhone{
  padding-bottom 40px
  position relative

  > div:nth-of-type(4){
    display flex
    position absolute
    top 60px
    left 0px
  }
  > div:nth-of-type(4) input{
    font-size: 28px;
    margin-left 105px
  }
  
}

.btn-bottom {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 80px;
  line-height: 80px;
  font-size: 30px;
  display: flex;

  .price {
    background-color: #d5d5d5;
    width: 70%;
    padding-left: 20px;

    span {
      color: #FF4E00;
      margin-left: 30px;
    }
  }

  .next-btn {
    width: 30%;
    color: #ffffff;
    background-color: #2852A6;
    text-align: center;
  }
}

@media screen and (min-width: 800px) {
  .home {
    width: 900px;
    margin: 0 auto;
    min-height: 100vh;
    background: #fff;
    box-sizing: border-box;
    padding-bottom: 100px;

    h3 {
      font-size: 20px;
      font-weight: 700;
      padding: 20px 20px 0px 20px;
    }

   

    
  }
   /deep/.el-input__inner{
    color: #ff4e00;
    font-size: 20px;
    border: none;
    padding: 0px;
    /*margin-right: 2.133vw;*/
  }
  // /deep/ .el-message-box{
  //     width 200px
  //     height 200px
  // }

  .order-item {
    background: #ffffff;
    border: 1px solid #989898;
    margin: 20px;
    border-radius: 10px 10px 0 0;

    .order-info {
      color: #fff;
      font-size: 26px;
      border-bottom: 1px solid #D7D7D7;
      padding: 0;

      div {
        width: 100%;
        height: 100px;
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        background: rgba(117, 170, 211, 1);
        border-radius: 10px 10px 0 0;
        font-size: 20px;
        color: #ffffff;
        box-sizing: border-box;
        padding: 20px;

        p {
          width: 50%;
          display: inline-block;
          text-align: left;
        }

        p:nth-of-type(1) {
          width: 100%;
          margin-bottom: 20px;
        }
      }
    }
  }
  .leave-time{
    width 50%
    font-size 16px
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 170px;
    }
  }
  
  .choose-time {
    padding: 20px 10px;
    border-bottom: 1px solid #D7D7D7;
    display: flex;
    margin 0 15px
    div:nth-of-type(1) {
      width 110px
      font-size 20px
    }
  }

  .rooms {
    padding: 0 24px;
  }

  .total {
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    font-size: 22px;
    border-bottom: 1px solid #D7D7D7;
    span:nth-of-type(1){
      width 660px
    }
    span:nth-of-type(2){
      width 370px
    }
  }

  .rooms-num {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 60px;
    font-size: 20px;
    border-bottom: 1px solid #D7D7D7;

    div:nth-of-type(1) {
      width: 120px;
    }

    div:nth-of-type(2) {
      width: 400px;
      text-align: left;

      input {
        border: none;
        font-size 22px
      }
    }

    div:nth-of-type(3) {
      width: 165px;
      display: flex;
      align-items: center;

      img {
        width: 28px;
        margin-right: 12px;
      }

      >span:nth-of-type(1) {
        margin-right: 20px;
      }

      .check {
        display: inline-block;
        width: 28px;
        height: 28px;
        vertical-align: text-top;
        background: url('../../views/tickets/static/checked.png');
        -webkit-background-size: 28px 28px;
        background-size: 28px 28px;
      }

      .uncheck {
        display: inline-block;
        width: 28px;
        height: 28px;
        vertical-align: text-top;
        background: url('../../views/tickets/static/unchecked.png');
        -webkit-background-size: 28px 28px;
        background-size: 28px 28px;
      }
    }

    .arrow {
      text-align: right;
      position: relative;

      span {
        position: absolute;
        left -305px
        top -6px
        font-family serif
        font-weight 700
        width 10px
        height 10px
        line-height 10px
        transform: rotate(90deg);
      }
    }
  }
  .roomPhone{
    padding-bottom 40px
    position relative

    > div:nth-of-type(4){
      display flex
      position absolute
      top 50px
      left 0px
    }
    > div:nth-of-type(4) input{
      font-size: 22px;
      margin-left 66px
    }
    
  }
  .price-bottom {
    position: relative;
    height: 48px;
    line-height: 48px;
    font-size: 30px;
    color: #FF4E00;
    .price {
      padding-left 20px
      span {
        margin-left: 20px;
      }
    }

    .next-btn {
      position absolute
      top 0
      left 50%
      width 188px
      height 48px
      font-size 20px
      font-weight 700
      border-radius 10px
      transform translateX(-50%)
      color: #ffffff;
      background-color: #2852A6;
      text-align: center;
    }
  }

}
</style>
